// Ajax post for normal cookies
common.View.create('galaxy::habitats.website.partials.Cookies', {

    onDOMLoad()
    {
        this.initModal();
        this.initSendForm();
    },

    initModal()
    {
        this.element.find('[data-target="#cookiesModal"]')
            .on('click', (event) => {
                $('body').addClass('tw-overflow-hidden')
                    .find('.modals #cookiesModal').fadeIn('fast');
            });
    },

    initSendForm()
    {
        this.element.find('form')

            .on('submit', (event) =>
            {
                // Ajax call
                $.post('/save-cookies', { allCookies: 1 } )
                    .done(() => {
                        this.element.find('form').hide();
                    });

                // Stop submit
                return false;
            })
            .end();
    }

});

// Ajax post for modal cookies
common.View.create('galaxy::habitats.website.partials.cookies.Modal', {

    onDOMLoad()
    {
        this.initClose();
        this.initSendForm();
    },

    initClose()
    {
        // Click outside of div?
        $('#cookiesModal')
            .on('click', (event) => {
                let container = this.element;

                // Check for click outside div
                if( !container.is(event.target) && container.has(event.target).length === 0 ) {
                    $('body').removeClass('tw-overflow-hidden')
                        .find('.modals #cookiesModal').fadeOut('fast');
                }
            });

        // Dismiss by close button
        this.element
            .find('[data-dismiss]')
                .on('click', (event) => {
                    $('body').removeClass('tw-overflow-hidden')
                        .find('.modals #cookiesModal').fadeOut('fast');
                })
                .end();
    },

    initSendForm()
    {
        this.element.find('form button[type="submit"]')

            .on('click', (event) =>
            {
                // Get form data
                let data = this.element.find('form').serializeArray();
                data.push({ name: event.currentTarget.name, value: event.currentTarget.value });

                // Ajax call
                $.post('/save-cookies', data)
                    .done(() => {
                        // Hide modal
                        $('body').removeClass('tw-overflow-hidden')
                            .find('.modals #cookiesModal').fadeOut('fast');

                        // Hide 'footer' cookies
                        $('.galaxy\\:\\:habitats-website-partials-Cookies').find('form').hide();
                    });

                // Stop submit
                return false;
            })
            .end();
    }

});
